import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import React, { useContext } from 'react';
import { ModelContext } from './contexts.ts';
import { Dropdown } from 'primereact/dropdown';
import { Slider } from 'primereact/slider';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { Button } from 'primereact/button';
export default function CustomizerPanel({ className, style }) {
    const model = useContext(ModelContext);
    if (!model)
        throw new Error('No model');
    const state = model.state;
    const handleChange = (name, value) => {
        model.setVar(name, value);
    };
    const groupedParameters = (state.parameterSet?.parameters ?? []).reduce((acc, param) => {
        if (!acc[param.group]) {
            acc[param.group] = [];
        }
        acc[param.group].push(param);
        return acc;
    }, {});
    const groups = Object.entries(groupedParameters);
    const collapsedTabSet = new Set(state.view.collapsedCustomizerTabs ?? []);
    const setTabOpen = (name, open) => {
        if (open) {
            collapsedTabSet.delete(name);
        }
        else {
            collapsedTabSet.add(name);
        }
        model.mutate(s => s.view.collapsedCustomizerTabs = Array.from(collapsedTabSet));
    };
    return (_jsx("div", { className: className, style: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '80vh',
            overflow: 'scroll',
            ...style,
            bottom: 'unset',
        }, children: groups.map(([group, params]) => (_jsx(Fieldset, { style: {
                margin: '5px 10px 5px 10px',
                // backgroundColor: 'transparent',
                backgroundColor: 'rgba(255,255,255,0.04)',
            }, onCollapse: () => setTabOpen(group, false), onExpand: () => setTabOpen(group, true), collapsed: collapsedTabSet.has(group), legend: group, toggleable: true, children: params.map((param) => (_jsx(ParameterInput, { value: (state.params.vars ?? {})[param.name], param: param, handleChange: handleChange }, param.name))) }, group))) }));
}
;
function ParameterInput({ param, value, className, style, handleChange }) {
    return (_jsxs("div", { style: {
            flex: 1,
            ...style,
            display: 'flex',
            flexDirection: 'column',
        }, children: [_jsxs("div", { style: {
                    flex: 1,
                    display: 'flex',
                    margin: '10px -10px 10px 5px',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }, children: [_jsxs("div", { style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                        }, children: [_jsx("label", { children: _jsx("b", { children: param.name }) }), _jsx("div", { children: param.caption })] }), _jsxs("div", { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }, children: [param.type === 'number' && 'options' in param && (_jsx(Dropdown, { style: { flex: 1 }, value: value || param.initial, options: param.options, onChange: (e) => handleChange(param.name, e.value), optionLabel: "name", optionValue: "value" })), param.type === 'string' && param.options && (_jsx(Dropdown, { value: value || param.initial, options: param.options, onChange: (e) => handleChange(param.name, e.value), optionLabel: "name", optionValue: "value" })), param.type === 'boolean' && (_jsx(Checkbox, { checked: value ?? param.initial, onChange: (e) => handleChange(param.name, e.checked) })), !Array.isArray(param.initial) && param.type === 'number' && !('options' in param) && (_jsx(InputNumber, { value: value || param.initial, showButtons: true, size: 5, onValueChange: (e) => handleChange(param.name, e.value) })), param.type === 'string' && !param.options && (_jsx(InputText, { style: { flex: 1 }, value: value || param.initial, onChange: (e) => handleChange(param.name, e.target.value) })), Array.isArray(param.initial) && 'min' in param && (_jsx("div", { style: {
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                }, children: param.initial.map((_, index) => (_jsx(InputNumber, { style: { flex: 1 }, value: value?.[index] ?? param.initial[index], min: param.min, max: param.max, showButtons: true, size: 5, step: param.step, onValueChange: (e) => {
                                        const newArray = [...(value ?? param.initial)];
                                        newArray[index] = e.value;
                                        handleChange(param.name, newArray);
                                    } }, index))) })), _jsx(Button, { onClick: () => handleChange(param.name, param.initial), style: {
                                    marginRight: '0',
                                    visibility: value === undefined || (JSON.stringify(value) === JSON.stringify(param.initial)) ? 'hidden' : 'visible',
                                }, tooltipOptions: { position: 'left' }, icon: 'pi pi-refresh', className: 'p-button-text' })] })] }), !Array.isArray(param.initial) && param.type === 'number' && param.min !== undefined && (_jsx(Slider, { style: {
                    flex: 1,
                    minHeight: '5px',
                    margin: '5px 40px 5px 5px',
                }, value: value || param.initial, min: param.min, max: param.max, step: param.step, onChange: (e) => handleChange(param.name, e.value) }))] }));
}
